export function index (filters)
{
    return axios.get(
    	route('api.manage.companies.permissions'),
    	{ params: {
    		...filters,
    		offset: 0,
    		limit: 9999,
    	}}
    ).then(response => response.data);
}

export function users (prefix, model_id) {
    return axios.get(route('api.manage.companies.permissions.users') + `?prefix=${prefix}&model_id=${model_id}`)
        .then(response => response.data);
}

export function setLevel(prefix, model_id, user_id, level) {
    return axios.post(route('api.manage.companies.permissions.users'), {
        prefix,
        model_id,
        user_id,
        level
    });
}
